import * as i0 from '@angular/core';
import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import * as i1 from '@angular/router';
import * as i2 from 'app-services-library';

class ImagilityWebStorage {
    constructor(router, sessionRelatedServiceService) {
        this.router = router;
        this.sessionRelatedServiceService = sessionRelatedServiceService;
        this.reloadSubject = new BehaviorSubject(false);
        this.reloadTrigger = this.reloadSubject.asObservable();
    }
    setWebStorageItem(key, value) {
        sessionStorage.setItem(key, JSON.stringify(value));
    }
    getWebStorageItem(key) {
        return JSON.parse(sessionStorage.getItem(key));
    }
    removeWebStorageItem(key) {
        sessionStorage.removeItem(key);
    }
    /*IM3069*/
    startLocalstorageEventListening() {
        window.addEventListener("storage", this.storageEventListener.bind(this));
    }
    storageEventListener(event) {
        if (event.target.hasOwnProperty('localStorage') && event.key == 'session_end') {
            localStorage.setItem('UserToken', null);
            localStorage.setItem('userTypeRole', null);
            this.sessionRelatedServiceService.clearSessionStorage();
            this.router.navigate(['/login']);
        }
        if (event.target.hasOwnProperty('localStorage') && localStorage.getItem('UserToken') !== 'null' && event.key == 'UserToken') {
            if (sessionStorage.getItem('currentUser') && sessionStorage.getItem('currentUser') !== 'null') {
                if (localStorage.getItem('UserToken') !== JSON.parse(sessionStorage.getItem('currentUser'))['jwt']) {
                    this.reloadSubject.next(true);
                }
            }
        }
    }
    stopLocalstorageEventListening() {
        window.removeEventListener("storage", this.storageEventListener.bind(this));
    }
    sessionEndTimestamping() {
        let timestamp = new Date().getTime();
        localStorage.setItem('session_end', timestamp.toString());
    }
}
ImagilityWebStorage.ɵfac = function ImagilityWebStorage_Factory(t) { return new (t || ImagilityWebStorage)(i0.ɵɵinject(i1.Router), i0.ɵɵinject(i2.SessionRelatedServiceService)); };
ImagilityWebStorage.ɵprov = i0.ɵɵdefineInjectable({ token: ImagilityWebStorage, factory: ImagilityWebStorage.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ImagilityWebStorage, [{
        type: Injectable,
        args: [{ 'providedIn': 'root' }]
    }], function () { return [{ type: i1.Router }, { type: i2.SessionRelatedServiceService }]; }, null); })();

/*
 * Public API Surface of web-storage
 */

/**
 * Generated bundle index. Do not edit.
 */

export { ImagilityWebStorage };
//# sourceMappingURL=web-storage.js.map
